var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eight wide column pl-0 pt-0 pb-05"},[_c('div',{staticClass:"is-uppercase"},[_vm._v("Grafica semanal de envios")]),_c('canvas',{attrs:{"id":"weekly_sends"}})])
}]

export { render, staticRenderFns }